import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";

const API_BASE =
  process.env.REACT_APP_API_URL ||
  "http://localhost:3001";

function getToken() {
  try {
    const auth = JSON.parse(localStorage.getItem("auth") || "null");
    return auth?.token || null;
  } catch {
    return null;
  }
}

export default function AdminRoute({ children }) {
  const [ok, setOk] = useState(null);

  useEffect(() => {
    let alive = true;

    (async () => {
      try {
        const token = getToken();
        if (!token) {
          if (alive) setOk(false);
          return;
        }

        const res = await fetch(`${API_BASE}/api/admin/whoami`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        if (!alive) return;
        setOk(res.ok);
      } catch {
        if (alive) setOk(false);
      }
    })();

    return () => {
      alive = false;
    };
  }, []);

  if (ok === null) return null;
  if (!ok) return <Navigate to="/dashboard" replace />;
  return children;
}
